module.exports = __webpack_public_path__ + "img/webmaster.0eef21f4.svg";